import { Box, Stack } from '@mui/material';
import React from 'react';
import { styled } from "@mui/material/styles";
import { useTranslation } from 'react-i18next';

interface CreationUpdateDetailsProps {
  details?: {
    createdBy?: string;
    createdDate?: string;
    updatedBy?: string;
    updatedDate?: string;
  }
}
const Item = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
function CreationUpdateDetails({ details }: CreationUpdateDetailsProps) {
    const { createdBy, createdDate,  updatedBy,  updatedDate } = details || {};
    const {t} = useTranslation();

  return (
     <>
      {(!!createdDate && !!createdBy) ||
      (!!updatedDate && !!updatedBy) ? (
        <Stack
          className="bottom-bar-container"
          direction="row"
          spacing={16}
          sx={{ marginBottom: "32px"}}
        >
          {!!createdDate && !!createdBy ? (
            <Item>
              <span>{t("common.createdBy")}: </span>
              <span className="bottom-bar-detail">
                {t("common.userOnDate", {
                  user: createdBy,
                  date: createdDate
                })}
              </span>
            </Item>
          ) : null}
          {!!updatedDate && !!updatedBy ? (
            <Item>
              <span>{t("common.lastModifiedBy")}: </span>
              <span className="bottom-bar-detail">
                {t("common.userOnDate", {
                  user: updatedBy,
                  date: updatedDate
                })}
              </span>
            </Item>
          ) : null}
        </Stack>
      ) : null}
    </>
  )
}

export default CreationUpdateDetails